/* Closing a picker menu without a pick (designs/intake-unified-form.md
   UF15-b): a press anywhere outside the picker, Escape, or focus leaving it.
   Spread the returned props on the picker's wrapper. Escape is stopped only
   while the menu is open, so the first press closes the menu and the next
   one still reaches the drawer's window-level handler (CONTRACT.md §7). */
import { useEffect, useRef, type FocusEvent, type KeyboardEvent } from "react";

export function useDismiss(open: boolean, setOpen: (open: boolean) => void) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent): void => {
      if (ref.current !== null && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open, setOpen]);
  return {
    ref,
    onKeyDown: (e: KeyboardEvent<HTMLDivElement>): void => {
      if (!open || e.key !== "Escape") return;
      e.stopPropagation();
      setOpen(false);
    },
    /* a null relatedTarget (a press on blank page) is the mousedown's job */
    onBlur: (e: FocusEvent<HTMLDivElement>): void => {
      const next = e.relatedTarget as Node | null;
      if (next !== null && !e.currentTarget.contains(next)) setOpen(false);
    },
  };
}
